<template>
	<div v-if="data !== undefined" :class="['sub-values', {'inline': data === null}]">
		<div v-if="data === null" class="sub-value clickable" @click="$emit('click')">
			<div class="label">Keine Ausbildung nötig</div>
		</div>
		<template v-else>
			<div class="sub-value clickable" @click="$emit('click')">
				<div class="label">Art der Ausbildung</div>
				<div>
					<Label :characteristic="data.schoolType" :label-type="labelTypeJobProfile"/>
				</div>
			</div>
			<div v-if="data.professions" class="sub-value clickable" @click="$emit('click')">
				<div class="label">Fachliche Schwerpunkte</div>
				<div>
					<LabelList
						:characteristics="getCharacteristicsLastLevel(data.professions)"
						:label-type="labelTypeJobProfile"
					/>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
import Label from "@/vue/characteristic/Label.vue";
import {JOB_PROFILE} from "@/helper/characteristic/Label";
import LabelList from "@/vue/characteristic/LabelList.vue";
import {filterLastLevel} from "@/helper/characteristic/Characteristic";

export default {
	components: {
		LabelList,
		Label
	},

	props: {
		data: {
			type: Object,
			required: false
		}
	},

	computed: {
		labelTypeJobProfile ()
		{
			return JOB_PROFILE;
		},
	},

	methods: {
		getCharacteristicsLastLevel (items)
		{
			return _.map(filterLastLevel(items), 'item');
		}
	}
}
</script>
